<template>
    <div v-html="html" class="outer" :class="theme"></div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'StaticView',
  data: function () {
    return { html: '' }
  },
  props: {
    url: {
      type: String,
      required: true
    },
    theme: {
      type: String,
      default: 'rtl'
    }
  },
  created: function () {
    var t = this
    axios.get(this.url).then(function (r) { t.html = r.data })
  }
}
</script>

<style>
  .ltr {
    direction: ltr;
    text-align: left
  }
  .outer {
    padding: 30px;
  }

  .outer h1 {
    padding:0px;
  }

  .outer pre {
    border-inline-start: 4px solid #880000;
    border-radius: 0px;
    word-wrap: normal;
    white-space: pre-line;
    padding: 10px 10px 10px 20px;
    font-size: 14px;
    line-height: 28px;
    background-color: #F6F6F6;
  }
</style>
